import { render, staticRenderFns } from "./FreightTableTag.vue?vue&type=template&id=7d95806b&scoped=true"
import script from "./FreightTableTag.vue?vue&type=script&lang=js"
export * from "./FreightTableTag.vue?vue&type=script&lang=js"
import style0 from "./FreightTableTag.vue?vue&type=style&index=0&id=7d95806b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d95806b",
  null
  
)

export default component.exports